import * as types from '../actions/types';

const initialState = {
    queryCategoryData:[],
    success: false
}

export default function queryCategoryReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.GET_QUERY_CATEGORY_LIST:
            return {
               
                queryCategoryData:action.payload.data,
                success: true
            } 
        default:
            return state
    }
}
